<template>
    <v-card primary elevation="5" style="background: linear-gradient( to right, rgba(255, 255, 255, 0.1) 70%, rgba(135, 226, 200, 0.4) 100% );">
        <v-layout row wrap align-center mt-5 mr-2>
            <v-flex xs8 md10 pl-5>
                <v-layout pa-2 column>
                    {{title}}
                    <v-toolbar-title style="color:#FF5429; font-size: xx-large;">
                        {{value}}
                    </v-toolbar-title>
                </v-layout>
            </v-flex>
             <v-flex xs4 md1 >
                <v-icon color="#10303D"  large >{{icon}}</v-icon>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    props:{
        icon: String,
        title: String,
        value: [String, Number],
    }
}
</script>
